/**
 * Fancy text is text which for english uses an image, and for non-english uses titan text.
 */
import { TitanSprite } from "@lib/titan2/dist/game/control/TitanSprite";
import { TitanTextResize } from "../TitanTextResizer";
export class TitanFancyTextFactory {
    static CreateElement(parent, langManager, landscape, portrait) {
        //Some non-english languages may use the same word for certain keys therefore we check if they are the same
        const localised = langManager.getLang(landscape.text.langKey ?? "");
        if (localised.toLowerCase() !== landscape.targetText.toLowerCase()) {
            return TitanTextResize.createField(parent, landscape.text, portrait?.text);
        }
        return TitanSprite.createSprite(parent, "", landscape.image, portrait?.image);
    }
}
//# sourceMappingURL=TitanFancyTextFactory.js.map